import { generateUUId } from '@/utils/util.js';

export default () => {
  const deviceId = localStorage.getItem('deviceId')
  if(!deviceId) {
    localStorage.setItem('deviceId', generateUUId())
  }
};
